import React from 'react';
import { IconButton } from '@material-ui/core';
import { PlayArrow, GitHub } from '@material-ui/icons';

import './Projects.css';

import sorting from '../img/featured/sorting.jpg';
import checklist from '../img/featured/checklist.png';
import archhive from '../img/featured/archhive.png';
import web3d from '../img/featured/web3d.gif';
import kaleidio from '../img/featured/kaleidio.jpg';

const ExperienceCard = ({ title, image, description, tags, url, source}) => {
  return (
    <div className="project card">
      <figure className="project-pic">
        <a href={url} target="_blank">
          <img className="project-img" src={image} />
        </a>
      </figure>
      <figcaption className="project-caption">
        <h3 className="project-name">
          <a href={url} target="_blank">{title}</a>
        </h3>
        <p>{description}</p>
        <p>
          {tags.map(tag => <div className="tool">{tag}</div>)}
        </p>

        <IconButton variant="contained" onClick={() => window.open(url, "_blank")}>
          <PlayArrow />
        </IconButton>
        {source && (
          <IconButton variant="contained" onClick={() => window.open(source, "_blank")}>
            <GitHub />
          </IconButton>
        )}
      </figcaption>
    </div>
  )
}

export default function Projects() {
  return (
    <section className="section featured-projects" data-sr-id="4">
      <div className="section-title">Featured Projects</div>
      <div className="section-content">

      {/* <div className="project card">
          <figure className="project-pic">
            <img className="project-img" src={kaleidio} />
          </figure>
          <figcaption className="project-caption">
            <h3 className="project-name"> <a href="https://kaleidio.ai/" target="_blank">Kaleidio.ai</a> </h3>
            <p>Adaptation of Looking Glass into a web service</p>
            <p>Currently managing thousands of users grossing five-figure yearly revenue.</p>
            <p>
              <div className="tool">PyTorch</div>
              <div className="tool">Flask</div>
              <div className="tool">Python</div>
              <div className="tool">Jupyter Notebook</div>
            </p>

            <IconButton variant="contained" onClick={() => window.open("https://kaleidio.ai/", "_blank")}>
              <PlayArrow />
            </IconButton>
          </figcaption>
        </div> */}

        <ExperienceCard 
          title='Arch Hive - Online communtiy for architects' 
          description='All-in-one community and marketplace for architects and students. Currently managing thousands of users grossing five-figure yearly revenue.'
          image={archhive}
          tags={[ "TypeScript", "React", "Nodejs", "Express", "Stripe", "MongoDB", "AWS S3" ]}
          url='https://arch-hive.com/'
          />

        <ExperienceCard 
          title='Sorting Algorithm Visualizer' 
          description='This is a React frontend web app used to visualize classic sorting algorithms such as bubble sort, merge sort, and quick sort with variety of arrays and speed options.'
          image={sorting}
          tags={[ "React", "Material-UI" ]}
          url='https://bennettoh.github.io/sorting-visualizer'
          source='https://github.com/bennettoh/sorting-visualizer'
          />

        <ExperienceCard 
          title='React Checklist' 
          description='Minimalist front-end application made with React. It includes features to add/edit/delete entries and re-order them at will.'
          image={checklist}
          tags={[ "React", "Material-UI" ]}
          url='https://bennettoh.github.io/checklist-app/'
          source='https://github.com/bennettoh/checklist-app'
          />

        <ExperienceCard 
          title='Web3D' 
          description='Interactive 3D modeling environment on web browser. It utilizes WebGL with the aid of three.js library.'
          image={web3d}
          tags={[ "JavaScript", 'three.js' ]}
          url='https://bennettoh.github.io/web3d/'
          />

        {/* <div className="project card">
          <figure className="project-pic">
            <img className="project-img" src={archituts} />
          </figure>
          <figcaption className="project-caption">
            <h3 className="project-name"> <a href="https://archituts.com/" target="_blank">E-Learning Platform</a> </h3>
            <p> Online learning platform for architects and students. Currently managing hundreds of users and thousands of sesseions monthly.</p>
            <p>
              <div className="tool">JavaScript</div>
              <div className="tool">JQuery</div>
              <div className="tool">Bootstrap</div>
              <div className="tool">Firebase</div>
              <div className="tool">YouTube API</div>
            </p>

            <IconButton variant="contained" onClick={() => window.open("https://archituts.com/", "_blank")}>
              <PlayArrow />
            </IconButton>
          </figcaption>
        </div> */}

      </div>
    </section>
  );
}